function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "map_search_result");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M185.43,0C83.18,0,0,83.18,0,185.43c0,126.88,165.94,313.16,173,321a16.71,16.71,0,0,0,24.85,0c7.07-7.87,173-194.15,173-321C370.85,83.18,287.67,0,185.43,0Zm0,278.72a93.3,93.3,0,1,1,93.29-93.29A93.4,93.4,0,0,1,185.43,278.72Z",
  fill: "#6c6c6c"
});

var SvgMapSearchResult = function SvgMapSearchResult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 370.85,
    height: 512,
    viewBox: "0 0 370.85 512",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMapSearchResult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_search_result.26376b27.svg";
export { ForwardRef as ReactComponent };